angular
  .module("dettagliCalcolo.components", [])
  .component("dettagliCalcolo", {
    templateUrl: "ng/components/dettagliCalcolo/dettagliCalcolo.view.html",
    bindings: {},
    controllerAs: "dettagliCalcoloCtrl",
    controller: function dettagliCalcoloCtrl(
      $transactionFactory,
      $location,
      $download,
      $portalService
    ) {

      var self = this;
      self.$onInit = function () {

        self.model = $transactionFactory.get();
        $transactionFactory.clear();
        console.log(self.model);
        self.showPurchaseOption = self.model.anno >= 2024 ? true : false;
      }

      self.printReportIrap = function (contratto) {
        var url =
          "/arc/printReportIrap/service-infos/" +
          encodeURIComponent(contratto.numeroContratto) +
          "/" +
          encodeURIComponent(contratto.anno) +
          "/" +
          encodeURIComponent(contratto.numeroModulo)

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      }

      self.back = function () {
        if ($portalService.isAru()) {
          $location.path('/calcoloIrap');
        } else {
          $location.path('/calcoloIrapAra');
        }
      }
    }
  }); 